export function EliteTabPlanSwitcherIcon() {
  return (
    <svg
      width='36'
      height='13'
      viewBox='0 0 36 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <g filter='url(#filter0_i_elite_tab)'>
        <path
          d='M23.3477 4.03027H25.7803V5.86621H23.3984V9.59277C23.3985 10.0753 23.5389 10.4461 23.8203 10.7051C24.1019 10.9523 24.5024 11.0762 25.0205 11.0762C25.4034 11.0762 25.8201 11.0171 26.2705 10.8994V12.7891C25.775 12.9303 25.2627 13.0009 24.7334 13.001C23.5507 13.001 22.6721 12.6768 22.0977 12.0293C21.5233 11.3819 21.2354 10.5523 21.2354 9.54004V5.86621H19.7656V4.03027H21.3027V1.36328H23.3477V4.03027ZM31.5576 3.8125C32.5375 3.8125 33.3599 4.01288 34.0244 4.41309C34.689 4.81337 35.1851 5.36105 35.5117 6.05566C35.8382 6.7383 36.0019 7.50324 36.002 8.35059C36.002 8.55073 35.9903 8.79264 35.9678 9.0752H29.1602C29.1915 9.63449 29.3422 10.0875 29.6152 10.4346C30.0433 10.9526 30.685 11.2119 31.541 11.2119C32.0929 11.2119 32.5488 11.0996 32.9092 10.876C33.2809 10.6523 33.5401 10.3697 33.6865 10.0283H35.917C35.7142 10.9466 35.2468 11.6714 34.5146 12.2012C33.7825 12.7308 32.8082 12.9951 31.5918 12.9951C30.1388 12.9951 29.001 12.6013 28.1787 11.8125C27.3565 11.012 26.9454 9.86995 26.9453 8.38672C26.9453 7.44487 27.1312 6.63206 27.5029 5.94922C27.8859 5.25468 28.4267 4.7253 29.125 4.36035C29.8233 3.99543 30.6341 3.81254 31.5576 3.8125ZM8.81934 2.54883H2.43262V5.26855H8.48145V7.31641H2.43262V10.707H8.8877V12.791H0V0.5H8.81934V2.54883ZM13.2959 12.7852H11.1328V0H13.2959V12.7852ZM18.1162 12.7852H15.9541V4.02637H18.1162V12.7852ZM31.5576 5.50781C30.7017 5.50788 30.0652 5.77882 29.6484 6.32031C29.3751 6.67562 29.2134 7.09969 29.1582 7.5918H33.8555C33.8555 6.99145 33.6588 6.49689 33.2646 6.1084C32.8704 5.70811 32.301 5.50781 31.5576 5.50781ZM17.2207 0C17.5699 0 17.8577 0.123858 18.083 0.371094C18.3194 0.606516 18.4375 0.906652 18.4375 1.27148V1.3418C18.4375 1.69499 18.3196 1.99593 18.083 2.24316C17.8577 2.49035 17.5699 2.61328 17.2207 2.61328H16.8496C16.5005 2.61328 16.2072 2.49611 15.9707 2.26074C15.7454 2.01351 15.6328 1.70676 15.6328 1.3418V1.27148C15.6328 0.906596 15.7455 0.606532 15.9707 0.371094C16.2072 0.123858 16.5004 0 16.8496 0H17.2207Z'
          style={{ fill: 'var(--ep-tab-glyph, #CC5C2D)' }}
        />
      </g>
      <defs>
        <filter
          id='filter0_i_elite_tab'
          x='0'
          y='0'
          width='36.002'
          height='13.4076'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.406628' />
          <feGaussianBlur stdDeviation='1.4232' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.604849 0 0 0 0 0.604849 0 0 0 0 0.604849 0 0 0 0.25 0'
          />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_elite_tab' />
        </filter>
      </defs>
    </svg>
  )
}
